module.exports = __webpack_public_path__ + "static/img/14.73d2b7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/14.jpg
// module id = njSn
// module chunks = 0